import { LOCATION_TYPES_ADDITIONAL_FIELDS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/location_types_additional_fields_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['locationsAdvancedFilters']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
